import {HttpRequest} from '../../../settings/HttpRequest/HttpRequest';
import {DateFormat} from "../../../settings/DateFormat/DateFormat";

export const PromocionService = {
	Listar: () => {
		let params = {};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Promocion_Datos', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Agregar: (form) => {
		let fecha_periodo_inicio = (form.fecha_periodo_inicio || null) ? DateFormat.FormatSql(form.fecha_periodo_inicio) : null;
		let fecha_periodo_fin = (form.fecha_periodo_fin || null) ? DateFormat.FormatSql(form.fecha_periodo_fin) : null;
		
		let params = {
			id_cat_promocion: null,
			promocion: form.promocion,
			codigo: form.codigo,
			fecha_periodo_inicio: fecha_periodo_inicio,
			fecha_periodo_fin: fecha_periodo_fin,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Promocion_Guardar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Modificar: (form) => {
		let fecha_periodo_inicio = (form.fecha_periodo_inicio || null) ? DateFormat.FormatSql(form.fecha_periodo_inicio) : null;
		let fecha_periodo_fin = (form.fecha_periodo_fin || null) ? DateFormat.FormatSql(form.fecha_periodo_fin) : null;
		
		let params = {
			id_cat_promocion: form.id_cat_promocion,
			promocion: form.promocion,
			codigo: form.codigo,
			fecha_periodo_inicio: fecha_periodo_inicio,
			fecha_periodo_fin: fecha_periodo_fin,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Promocion_Modificar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Eliminar: (id_cat_promocion) => {
		let params = {
			id_cat_promocion: id_cat_promocion
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Promocion_Eliminar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	}
};
